import { render, staticRenderFns } from "./LandsideFooterSection.vue?vue&type=template&id=75629f57&"
import script from "./LandsideFooterSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandsideFooterSection.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports